export default () => {
	document.addEventListener("DOMContentLoaded", () => {
		const bar = document.getElementById("back-to-top-bar");
		const pageHeader = document.getElementById("page-header");
		const transInClass = "opacity-z-in";
		const transOutClass = "opacity-z-out";
		const opacityDownClass = "opacity-0";
		const opacityUpClass = "opacity-100";
		const zDownClass = "z-0";
		const zUpClass = "z-40";

		// If bar and page header elements are found...
		if (bar !== null && pageHeader !== null) {
			const callback = (entries, observer) => {
				entries.forEach((entry) => {
					// Only run intersection checks if search modal is not open
					if (!document.body.classList.contains("search-modal-open")) {
						// If page header is not intersecting, show bar element, otherwise hide it
						if (!entry.isIntersecting) {
							bar.classList.remove(transOutClass);
							bar.classList.add(transInClass);
							bar.classList.remove(opacityDownClass);
							bar.classList.add(opacityUpClass);
							bar.classList.remove(zDownClass);
							bar.classList.add(zUpClass);

							// Remove tabindex attrs from links in bar to make sure they are tababble when bar is visible
							for (const item of bar.querySelectorAll("a")) {
								item.removeAttribute("tabindex");
							}
						} else {
							bar.classList.remove(transInClass);
							bar.classList.add(transOutClass);
							bar.classList.remove(opacityUpClass);
							bar.classList.add(opacityDownClass);
							bar.classList.remove(zUpClass);
							bar.classList.add(zDownClass);

							// Add tabindex attr to links in bar to make sure they are not tababble when bar is hidden
							for (const item of bar.querySelectorAll("a")) {
								item.setAttribute("tabindex", "-1");
							}
						}
					}
				});
			};

			// Add intersection observer to observe page header element
			let observer = new IntersectionObserver(callback);
			observer.observe(pageHeader);
		}
	});
};
